import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { eTypeResult } from 'src/app/models/common/enumModel';
import { ISolicitudStandByModel } from 'src/app/models/interfaces/solicitud/ISolicitudStandByModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { SolicitudService } from 'src/app/services/solicitud/solicitud.service';
import { SolicitudExtenderComponent } from '../../solicitud-extender/solicitud-extender.component';

@Component({
  selector: 'app-solicitud-quitar-stand-by-dialog',
  templateUrl: './solicitud-quitar-stand-by-dialog.component.html',
  styleUrls: ['./solicitud-quitar-stand-by-dialog.component.scss']
})
export class SolicitudQuitarStandByDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<SolicitudExtenderComponent>,
    private solicitudService: SolicitudService,
    private alertDialogService: AlertDialogService,
    @Inject(MAT_DIALOG_DATA) public model: ISolicitudStandByModel) { }

  ngOnInit() {
  }

  onSubmit(form: NgForm) {
    this.solicitudService.quitarstandby(this.model).subscribe((result : ActionResultModel) => {
      if(result.type!=eTypeResult.SUCCESS){
        this.alertDialogService.open(result.message);
      }    
      else{  
        this.dialogRef.close(true);
        this.alertDialogService.open('Se quitó de Stand By la solicitud');
      }
    });
  }

  onNoClick(){
    this.dialogRef.close(false);
  }

}
